var akpc_form_enable = function() {};
jQuery(function($) {
	var $html = $(document.documentElement);

	$html.on({
		change: function() {
			var $checkbox = $(this);
			if($checkbox.is(':checked')) {
				$checkbox.parents('.filter_group--buttons').find('input[type="checkbox"]').not($checkbox)
					.attr('checked', false);
			}
		}
	}, '.filter_group--buttons input[type="checkbox"]')
	return;

	var request;
	var duration = 'slow';
	var $form = $('form.filter_default ');

	if($form.length === 0) {
		return;
	}

	// nextIs is similar to $.next, but return the next sibling that is
	// matching the given selector, even if it is not directly beside it.
	$.fn.nextIs = function(selector) {
		return this.nextAll(selector).first();
	};

	$.fn.fadeIn = function(duration) {
		return this.animate({ opacity: 1 }, duration);
	};
	$.fn.fadeOut = function(duration) {
		return this.animate({ opacity: 0 }, duration);
	};

	// Scroll back to the form and the previous siblings bottom margin.
	var updatePagination = function() {
		var scrollTop = $form.offset().top - 32 - ($('.container-header').height() || 0);
		var $pagination = $form.nextAll('.pagecreator_pagination').first();
		$pagination.find('a.page-link').on('click', function(event) {
			event.preventDefault();
			var page = $(this).attr('href').match(/paged?[\/=]([0-9]+)/);
			if(page.length < 2) {
				return;
			}
			page = page[1];
			$('html, body').stop().animate({ scrollTop: scrollTop });
			update(page);
		});
	};

	var update = function(paged) {
		if(request !== undefined) {
			request.abort();
		}
		var $posttypelist = $form.nextIs('.pagecreator_posttypelist').fadeOut(duration);
		var $pagination = $form.nextIs('.pagecreator_pagination').fadeOut(duration);
		var $description = $form.find('.pagecreator_filter__description').fadeOut(duration);

		var data = $form.serializeArray();
		data.push({ name: 'action', value: 'get_akpc_form_filtered' });
		data.push({ name: 'paged', value: paged });
		request = $.post('/wp-admin/admin-ajax.php', data, function(data) {
			$posttypelist.replaceWith($(data).css({ opacity: 0 })).remove();
			$posttypelist = $form.nextIs('.pagecreator_posttypelist').fadeIn(duration);

			$pagination.remove();
			$pagination = $form.nextIs('.pagecreator_pagination').fadeIn(duration);

			$description.find('.pagecreator_filter__posts_found').text($pagination.attr('data-found-posts') || 0);
			$form.find('label[data-count]').attr('data-count', $pagination.attr('data-found-posts') || 0);
			$description.fadeIn(duration);

			updatePagination();
		});
	};

	var akpc_form_disable = function() {
		$form.find('input[type="checkbox"]:not([value=""])').addClass('disabled');
	};
	// akpc_form_enable is defined outside this anonymous function and gets
	// called after the search results are displayed. It recieves the IDs
	// (values) of filters that will return results.
	akpc_form_enable = function(filter_ids) {
		$.each(filter_ids, function(_, filter_id) {
			$form.find('input[type="checkbox"][value=' + filter_id + ']').removeClass('disabled');
		});
	};

	var loadFirstPage = function(e) {
		if(e && $(e.target).attr('data-ignore')) {
			return;
		}

		akpc_form_disable();
		update(0);
		updatePagination();
	};

	$form.find('.filter_button').hide();
	$form.on('change', loadFirstPage);

	loadFirstPage();

	$form.on({
		click: function() {
			var $checked_fields = $form.find(':checked').not('[data-ignore]').map(function() {
				$(this).prop('checked', false);
				return this;
			});

			if($('.filter_group--buttons :checked').length === 0) {
				$('.filter_group--buttons [type="checkbox"]').eq(0).prop('checked', true).change();
			}
			else {
				$checked_fields.eq(0).change();
			}

			return false;
		}
	}, '.reset-link');
});